import { Extension } from '@tiptap/core';

const ArcscriptIndentation = Extension.create({
  name: 'arcscriptIndentation',

  addOptions() {
    return {
      types: [],
      marginLeftDistance: 20,
      defaultIndentLevel: 0,
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          indentLevel: {
            default: this.options.defaultIndentLevel,
            parseHTML: element => {
              if (element.style.marginLeft.endsWith('px')) {
                return (
                  parseInt(element.style.marginLeft, 10) /
                  this.options.marginLeftDistance
                );
              }
              return this.options.defaultIndentLevel;
            },
            renderHTML: (attributes, a, b, c) => {
              if (attributes.indentLevel === this.options.defaultIndentLevel) {
                return {};
              }
              return {
                style: `margin-left: ${attributes.indentLevel *
                  this.options.marginLeftDistance}px`,
              };
            },
          },
        },
      },
    ];
  },

  onUpdate({ editor, transaction }) {
    const { state } = editor;
    let nextLevel = 0;
    const { tr } = state;
    const childNodes = [];
    const rootNodes = [];
    state.doc.descendants((node, offset, parent) => {
      // not root level element
      if (parent.type.name !== 'doc') {
        if (this.options.types.includes(node.type.name)) {
          if (node.attrs.indentLevel !== 0) {
            childNodes.push({
              node,
              offset,
              indentLevel: 0,
            });
          }
          // Continue to descendants of node
          return true;
        }
        // Do not go to descendants of node
        return false;
      }
      let token = null;
      let currentLevel = nextLevel;
      if (node.type.name === 'CustomCodeBlockLowLight') {
        [token] = node.textContent.trim().split(' ');
      }
      switch (token) {
        case 'if': {
          nextLevel += 1;
          break;
        }
        case 'elseif':
        case 'else': {
          currentLevel -= 1;
          break;
        }
        case 'endif': {
          currentLevel -= 1;
          nextLevel -= 1;
          break;
        }
        default:
          break;
      }
      // Do not go bellow 0
      currentLevel = Math.max(currentLevel, 0);

      if (node.attrs.indentLevel !== currentLevel) {
        rootNodes.push({
          node,
          offset,
          indentLevel: currentLevel,
        });
      }
      return true;
    });
    const nodeTransactions = rootNodes.concat(childNodes);

    nodeTransactions.forEach(nodeTransaction => {
      const { node, offset, indentLevel } = nodeTransaction;
      tr.setNodeMarkup(offset, undefined, {
        ...node.attributes,
        indentLevel,
      });
    });

    if (nodeTransactions.length > 0) {
      editor.view.dispatch(tr);
    }
  },
});

export default ArcscriptIndentation;
